export default __webpack_public_path__ + "static/Poppins-ExtraLightItalic-dbdfd398abcbbafc022b308f9ac48466.ttf";